<template>
  <LoginPage />
</template>

<script>
import LoginPage from './components/LoginPage.vue';

export default {
  name: 'App',
  components: {
    LoginPage,
  },
  data: () => ({
    //
  }),
};
</script>